import { useSelector } from "react-redux";

export default function useHasRoles(allowedRoles) {
  const { currentUser } = useSelector((state) => state.userAwb);
  const { roles } = currentUser;

  if (!allowedRoles || !roles) return false;
  const userRoles = allowedRoles.filter(r => roles.includes(r));
  return userRoles.length > 0 ? true: false;
}